module.exports = __webpack_public_path__ + "static/media/education-center-header01.2a996007.jpg";